import * as React from 'react';
import { 
  ProgramsActionTypes, 
  LevelsActionTypes, 
  ScheduleActionTypes, 
  EntityStatus,
  ProgramMemberActionTypes
} from './Types';
import MenuItem from 'material-ui/MenuItem';
import { Days } from '../app/app.const';

export const GET_PROGRAMS: ProgramsActionTypes = 'GET_PROGRAMS';
export const REGISTER_PROGRAM: ProgramsActionTypes = 'REGISTER_PROGRAM';
export const UPDATE_PROGRAM: ProgramsActionTypes = 'UPDATE_PROGRAM';
export const DELETE_PROGRAM: ProgramsActionTypes = 'DELETE_PROGRAM';
export const UPDATE_PROGRAM_MEMBERS: ProgramsActionTypes = 'UPDATE_PROGRAM_MEMBERS';

export const GET_PROGRAM_MEMBERS: ProgramMemberActionTypes = 'GET_PROGRAM_MEMBERS';

export const GET_LEVELS: LevelsActionTypes = 'GET_LEVELS';
export const UPDATE_LEVELS: LevelsActionTypes = 'UPDATE_LEVELS';
export const UPDATE_SCHEDULES: ScheduleActionTypes = 'UPDATE_SCHEDULES';

export const REMAINED: EntityStatus = 'REMAINED';
export const UPDATED: EntityStatus = 'UPDATED';
export const CREATED: EntityStatus = 'CREATED';
export const DELETED: EntityStatus = 'DELETED';

export const PROGRAM_NAME_LEVELS_SEPARATOR = ' - ';
export const TIME_SEPARATOR = '-';
export const HOUR_MIN_SEPARATOR = ':';
export const PROGRAM_NAME_ERROR_MESSAGE: string = 'Program name cannot be empty or contain any special character';
export const EVENT_TIME_ERROR_MESSAGE: string = 'Error exists in time field(s)';
export const EVENT_DAYS_ERROR_MESSAGE: string = 'Need to select at least one day';

export const DEFAULT_PROGRAM_ID = 0;
export const DEFAULT_LEVEL_ID = 0;

export const initialDefaultProgramsState = {
  statusCode: 0,
  programs: [],
  eventAction: undefined,
  selectedEvent: undefined
};

export const LEVELS = [
  <MenuItem key={0} value={''} primaryText={''} />,
  <MenuItem key={3} value={'WHITE'} primaryText={'WHITE'} />,
  <MenuItem key={2} value={'YELLOW'} primaryText={'YELLOW'} />,
  <MenuItem key={1} value={'BLUE'} primaryText={'BLUE'} />,
  <MenuItem key={4} value={'BLACK'} primaryText={'BLACK'} />
];

export const WEEKVIEW_DAYS = [
  <MenuItem key={0} value={Days.Monday} primaryText={Days.Monday} />,
  <MenuItem key={1} value={Days.Tuesday} primaryText={Days.Tuesday} />,
  <MenuItem key={2} value={Days.Wednesday} primaryText={Days.Wednesday} />,
  <MenuItem key={3} value={Days.Thursday} primaryText={Days.Thursday} />,
  <MenuItem key={4} value={Days.Friday} primaryText={Days.Friday} />,
  <MenuItem key={5} value={Days.Saturday} primaryText={Days.Saturday} />,
  <MenuItem key={6} value={Days.Sunday} primaryText={Days.Sunday} />,
];

export const UNSELECTED = {key: 0, label: ''};



// WEBPACK FOOTER //
// ./src/programs/Constants.tsx